(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.mediaGalleryReady === 'true') return;

    const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
    const modalItems = Array.from(gallery.querySelectorAll('[data-gallery-modal-item]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prevButtons = gallery.querySelectorAll('[data-gallery-prev]');
    const nextButtons = gallery.querySelectorAll('[data-gallery-next]');
    const openButtons = gallery.querySelectorAll('[data-gallery-open]');
    const closeButtons = gallery.querySelectorAll('[data-gallery-close]');
    const modal = gallery.querySelector('[data-gallery-modal]');
    const thumbnailScroller = gallery.querySelector('[data-gallery-thumbnails]');
    const zoomImages = Array.from(gallery.querySelectorAll('[data-gallery-zoom-image]'));

    if (!items.length || !thumbs.length) return;

    gallery.dataset.mediaGalleryReady = 'true';

    let current = Math.max(items.findIndex((item) => item.classList.contains('is-active')), 0);
    let galleryTouchStartX = 0;
    let modalTouchStartX = 0;
    let activeZoomItem = null;

    const resetZoom = () => {
      if (!activeZoomItem) return;

      const activeImage = activeZoomItem.querySelector('[data-gallery-zoom-image]');
      activeZoomItem.classList.remove('is-zoomed');
      if (activeImage) {
        activeImage.style.transformOrigin = 'center center';
        activeImage.style.translate = '';
      }
      activeZoomItem = null;
    };

    const scrollActiveThumbIntoView = () => {
      const activeThumb = thumbs[current];
      if (!activeThumb || !thumbnailScroller) return;

      activeThumb.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    };

    const setActive = (elements, index) => {
      elements.forEach((element, elementIndex) => {
        element.classList.toggle('is-active', elementIndex === index);
      });
    };

    const showImage = (index) => {
      const nextIndex = (index + items.length) % items.length;

      resetZoom();

      setActive(items, nextIndex);
      setActive(modalItems, nextIndex);

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === nextIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      current = nextIndex;
      window.requestAnimationFrame(scrollActiveThumbIntoView);
    };

    const openModal = () => {
      if (!modal) return;

      modal.hidden = false;
      document.body.classList.add('custom-gallery-modal-open');
      showImage(current);
    };

    const closeModal = () => {
      if (!modal || modal.hidden) return;

      resetZoom();
      modal.hidden = true;
      document.body.classList.remove('custom-gallery-modal-open');
    };

    prevButtons.forEach((button) => {
      button.addEventListener('click', () => showImage(current - 1));
    });

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => showImage(current + 1));
    });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showImage(index));
    });

    openButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        showImage(index);
        openModal();
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      });
    });

    gallery.addEventListener('touchstart', (event) => {
      galleryTouchStartX = event.touches[0].clientX;
    });

    gallery.addEventListener('touchend', (event) => {
      if (modal && !modal.hidden) return;

      const diff = event.changedTouches[0].clientX - galleryTouchStartX;
      if (Math.abs(diff) > 50) showImage(current + (diff > 0 ? -1 : 1));
    });

    if (modal) {
      modal.addEventListener('touchstart', (event) => {
        modalTouchStartX = event.touches[0].clientX;
      });

      modal.addEventListener('touchend', (event) => {
        if (activeZoomItem) return;

        const diff = event.changedTouches[0].clientX - modalTouchStartX;
        if (Math.abs(diff) > 50) showImage(current + (diff > 0 ? -1 : 1));
      });

      modal.addEventListener('click', (event) => {
        if (
          event.target.matches('[data-gallery-modal], [data-gallery-close]') ||
          event.target.closest('[data-gallery-close]')
        ) {
          closeModal();
        }
      });
    }

    zoomImages.forEach((image) => {
      const zoomItem = image.closest('[data-gallery-modal-item]');
      if (!zoomItem) return;

      image.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (activeZoomItem === zoomItem) {
          resetZoom();
          return;
        }

        resetZoom();
        activeZoomItem = zoomItem;
        zoomItem.classList.add('is-zoomed');
      });

      image.addEventListener('mousemove', (event) => {
        if (activeZoomItem !== zoomItem) return;

        const rect = zoomItem.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        image.style.transformOrigin = `${x}% ${y}%`;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') showImage(current - 1);
      if (event.key === 'ArrowRight') showImage(current + 1);
    });

    showImage(current);
  };

  const initGalleries = (container = document) => {
    container.querySelectorAll('[data-media-gallery]').forEach(initGallery);
  };

  initGalleries();

  document.addEventListener('DOMContentLoaded', () => initGalleries());
  document.addEventListener('shopify:section:load', (event) => initGalleries(event.target));
})();
